import React, { useEffect, useState, useMemo } from "react";
import { useRef } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";

import {
  Button,
  Col,
  Form,
  Row,
  InputGroup,
  Spinner,
} from "react-bootstrap";
import style from "./auth.module.css";
// import { Link } from "react-router-dom";
import { Country, State, City } from "country-state-city";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import * as Yup from "yup";
import { Formik } from "formik";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { registerCenter } from "../../apis/authApis";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import CenterRegisterSuccess from "../../modals/centerRegisterSuccess/CenterRegisterSuccess";
import { Helmet } from "react-helmet-async";
import { getAllCenters } from "../../apis/CenterApis";
import { IoMdRadioButtonOff, IoMdRadioButtonOn } from "react-icons/io";
// import ReactQuill from "react-quill";
import { baseUrl } from "../../utils/api";
// import "react-quill/dist/quill.snow.css";
import { toast } from "react-toastify";
import DonateModal from "../donation/donatemodal";
const GroupRegister = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const dateRef = useRef(null);


  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [selectedCity, setSelectedCity] = useState("");

  const [showPassword, setShowPassword] = useState(false);
  const [campaignList, setCampaignList] = useState(null);
  const [tempUserId, setTempUserId] = useState(null);
  const [nameError, setNameError] = useState("");
  const [churchDescription, setChurchDescrption] = useState("");

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const [showInfo, setShowInfo] = useState(false);
  const [showSuccessModal, setShowSucessModal] = useState(false);
  const [smsConsentChecked, setSmsConsentChecked] = useState(false);
  const [smsConsentError, setSmsConsentError] = useState("");
  const [showSmsInfo, setShowSmsInfo] = useState(false);

  const [disableButton, setDisableButton] = useState(false);
  const [showForm, setShowForm] = useState(false);

  const [checked, setChecked] = useState(null);
  const [prefilledCampaignId, setPrefilledCampaignId] = useState("");
  const [prefilledGoal, setPrefilledGoal] = useState("");
  const [isRegisterLoading, setIsRegisterLoading] = useState(false);

  const location = useLocation();
  const prefill = location?.state?.prefill || {};
  console.log("locationdat", prefill)

  useEffect(() => {
    if (!prefill) return;


    if (prefill.campaignId) {
      setPrefilledCampaignId(prefill.campaignId);
    }

    // if (prefill.goalAmmount) {
    //   setPrefilledGoal(prefill.goalAmmount);
    // }

  }, [prefill]);
  useEffect(() => {
    dispatch(getAllCenters({ page: 1, limit: 1000 })).then((res) => {
      if (res?.centersList) {
        // const filteredCenters = res.centersList.filter(
        //   (center) => !center.campaignId
        // );
        setCampaignList(res?.centersList);
      }
    });
  }, []);

  useEffect(() => {
    setCountries(Country.getAllCountries());
    // setCountries(countrylist)
  }, []);

  useEffect(() => {
    if (selectedCountry) {
      setStates(State.getStatesOfCountry(selectedCountry));
      setSelectedState("");
      setCities([]);
    }
  }, [selectedCountry]);


  useEffect(() => {
    if (selectedState && selectedCountry) {
      setCities(City.getCitiesOfState(selectedCountry, selectedState));
      setSelectedCity("");
    }
  }, [selectedState, selectedCountry]);

  const handleCountryChange = (e) => {
    setSelectedCountry(e.target.value);
  };

  const handleStateChange = (e) => {
    setSelectedState(e.target.value);
  };

  const handleCityChange = (e) => {
    setSelectedCity(e.target.value);
  };

  const [currentStep, setCurrentStep] = useState(0);
  const [messages, setMessages] = useState([]);  // bot + user messages
  const [userInput, setUserInput] = useState("");
  const [userName, setUserName] = useState("");
  const [userInitials, setUserInitials] = useState("");
  const [selectedChoice, setSelectedChoice] = useState("");
  // at top of component

  const [choicesMap, setChoicesMap] = useState({}); // store by question id

  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [showSecondEmailInput, setShowSecondEmailInput] = useState(false);
  const [phone, setPhone] = useState("");
  const [emailWasInvalid, setEmailWasInvalid] = useState(false);
  const [q11Choice, setQ11Choice] = useState(null); // Yes | No
  const [q11Text, setQ11Text] = useState("");
  const [password, setPassword] = useState("");
  const [passwordStrength, setPasswordStrength] = useState("");

  const [showAfterPassword, setShowAfterPassword] = useState(false);

  const [aiDescription, setAiDescription] = useState("");
  const [isAiLoading, setIsAiLoading] = useState(false);
  const [aiLoadingMessageId, setAiLoadingMessageId] = useState(null);
  const [campaignType, setCampaignType] = useState(null);

  const [emailErrorType, setEmailErrorType] = useState(null);

  const [showDonateModal, setShowDonateModal] = useState(false);

  const [q11Input, setQ11Input] = useState("");
  const [showCalendar, setShowCalendar] = useState(false);
  const [showClearAll, setShowClearAll] = useState(false);
  const [donationPrefill, setDonationPrefill] = useState(null);
  const [createdCampaignId, setCreatedCampaignId] = useState(null);
  const [campaignNameError, setCampaignNameError] = useState("");

  // const openDonateModal = () => setShowDonateModal(true);
  const openDonateModal = () => {

    const prefillData = {
      email: choicesMap?.[2]?.email || "",
      goalAmount: choicesMap?.[4] || "",
      campaignId: choicesMap?.[3]?.id || "",
      campaignName: choicesMap?.selectedCampaign?.centerName || "",
      campaignLaunchDate: choicesMap?.[5],
      contactPersonName: userName || choicesMap?.[1] || "",
      createdCampaignId: createdCampaignId,
      supportedCampaignLaunchDate: choicesMap?.selectedCampaign?.campaignLaunchDate,

    };

    setDonationPrefill(prefillData);
    setShowDonateModal(true);
  };
  const closeDonateModal = () => setShowDonateModal(false);

  const { id } = useParams();

  const chatScrollRef = useRef(null);
  const chatEndRef = useRef(null);



  useEffect(() => {
    const currentQuestion = QUESTIONS[currentStep];

    if (!currentQuestion) return;

    const qid = currentQuestion.id;

    if (choicesMap[qid]) {
      setUserInput(choicesMap[qid]);
    } else {
      setUserInput("");
    }
  }, [currentStep, choicesMap]);
  useEffect(() => {
    if (!id) return;

    const fetchGroupInviteData = async () => {
      try {
        const res = await fetch(`${baseUrl}/admin/group-registration/${id}`);
        const data = await res.json();
        console.log("data,,,", data.goalAmmount)
        if (!res.ok) {
          throw new Error(data.message || "Invalid invite link");
        }
        const prefilledData = {
          1: data.contactPersonName || "",
          2: {
            email: data.email || "",
            phone: data.phone || ""
          },
          3: {
            id: data.supportingCampaignId || "",
            name: data.supportingCampaign || ""
          },
          4: data.goalAmmount || "",
          5: data.campaignLaunchDate
            ? new Date(data.campaignLaunchDate).toISOString().split("T")[0]
            : "",
          6: data.centerName || "",

          7: data.supportReason || "", // NEW QUESTION
          8: data.website || "",
          10: data.description || "",
          9: data.contactPreference || "",

          campaignType: "Group"
        };
        setChoicesMap(prefilledData);

        // prefill editable fields
        setUserInput(data.contactPersonName || "");
        setEmail(data.email || "");
        setPhone(data.phone || "");

        setUserName(data.contactPersonName || "");
        setFirstName(getFirstName(data.contactPersonName || ""));
        setUserInitials(getInitials(data.contactPersonName || ""));
        setChurchDescrption(data.description)
        // show FIRST editable question only
        const firstQuestion = QUESTIONS[0];

        setCurrentStep(0);

        setMessages([
          {
            from: "bot",
            text: firstQuestion.text,
            type: firstQuestion.type,
            options: firstQuestion.options || [],
            placeholder: firstQuestion.placeholder || "",
            qid: firstQuestion.id
          }
        ]);

      } catch (error) {
        console.error("Invite prefill failed:", error);
        toast.error("Invalid or expired invite link");
      }
    };

    fetchGroupInviteData();
  }, [id]);

  // const validateEmail = (value) => {
  //   const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  //   return regex.test(value);
  // };
  const validateEmail = (value) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value);
  };
  const aiTextareaRef = useRef(null);
  const autoResizeTextarea = (el) => {
    if (!el) return;
    el.style.height = "auto";
    el.style.height = `${el.scrollHeight}px`;
  };

  const scrollChatToBottom = () => {
    if (!chatScrollRef.current) return;

    chatScrollRef.current.scrollTo({
      top: chatScrollRef.current.scrollHeight,
      behavior: "smooth",
    });
  };

  const getFirstName = (name) => {
    if (!name) return "";
    return name.trim().split(" ")[0];
  };
  const [firstName, setFirstName] = useState("");

  const QUESTIONS = [
    {
      id: 1,
      text: "Hello, I’m HOPE — your guide to starting a campaign on FundLife.me. First, let’s personalize your campaign. What’s your full name?",
      type: "text",
      placeholder: "Enter Your Name"
    },
    {
      id: 2,
      text: "Please enter your email address and phone number.",
      type: "email_phone",
    },

    {
      id: 9,
      text: "Thank you, {{name}}!. To support you with messaging and updates, would you prefer email or text?",
      type: "dropdown",
      options: ["Email", "Text", "Email and Text"],
    },

    {
      id: 3,
      text: "Which organization would you like to support through your campaign?",
      type: "dropdown",

    },

    {
      id: 4,
      text: "What’s your pledge goal — the amount you hope to raise?",
      type: "number",
      placeholder: "Enter Amount"
    },
    {
      id: 5,
      text: "When would you like your campaign to start?",
      type: "date"
    },

    {
      id: 6,
      text: "What would you like to name your campaign on behalf of  {{campaignName}}? Giving your campaign a unique name like Hope for Mothers and Children people feel connected to your goal. ",
      type: "text"
    },

    {
      id: 7,
      text: "Every campaign begins with a reason. What inspired you to support this cause?",
      type: "text"
    },

    {
      id: 8,
      text: "Does have a website or short description we can share with donors?",
      type: "yes_no_input"
    },

    {
      id: 10,
      text: "Thank you for sharing. If you’d like, we can use AI to combine your words with the recipient’s organization’s description. You’ll always have final say before anything is published.",
      type: "choice_text",
      options: ["Yes", "No"]
    }
    ,
    {
      id: 11,
      text: "Here’s a draft version. Would you like to approve this or keep your original wording?",
      type: "choice",
      options: ["Approve this version", "Keep original wording"]
    },
    {
      id: 12,
      text: "Great work. Now, let’s secure your campaign with a password.",
      type: "password",

    },
    {
      id: 13,
      text: "Once we wrap up, we’ll invite you to make a gift that kickstarts your campaign — no pressure, just possibility.",
      type: "final"
    },
    {
      id: 14,
      text: "Thank you, {{name}} Your campaign details are ready. Once you log on you will be able to update your profile, add a picture, track donations to your campaign and more.",
      type: "final"
    },

    {
      id: 15,
      text: "Together, we’re keeping hope alive — one story, one gift, one life at a time.",
      type: "final"
    }


  ];

  const MULTILINE_QUESTION_IDS = [6, 7, 8];

  const getInitials = (name) => {
    if (!name) return "";
    const words = name.trim().split(" ");
    if (words.length === 1) return words[0][0].toUpperCase();
    return (words[0][0] + words[words.length - 1][0]).toUpperCase();
  };

  // initial mount (example)
  useEffect(() => {
    if (id) return; // IMPORTANT: skip for invite flow

    const first = QUESTIONS[0];
    console.log("frist", first)
    setMessages([{
      from: "bot",
      text: first.text,
      type: first.type,
      options: first.options || [],
      placeholder: first.placeholder || "",
      qid: first.id
    }]);
    setCurrentStep(0);
  }, []);

  useEffect(() => {
    if (chatEndRef.current) {
      chatEndRef.current.scrollIntoView({
        behavior: "smooth",
        block: "end",
      });
    }
  }, [messages]);


  const lastSavedRef = useRef(null);

  const saveProgress = async (answers, step) => {
    if (!tempUserId) return;

    await fetch(`${baseUrl}/auth/save-progress`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        userId: tempUserId,
        answers,
        currentStep: step
      })
    });
  };



  const toTitleCase = (text) => {
    return text.replace(/\w\S*/g, (word) =>
      word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    );
  };
  const handleUserSubmit = async () => {
    // if (!userInput.trim()) return;

    const qid = QUESTIONS[currentStep].id;
    // ✅ Use prefilled value if userInput empty
    // use typed value first, otherwise fallback to prefilled answer
    let valueToSave = userInput || choicesMap[qid] || "";


    if (!valueToSave || !String(valueToSave).trim()) return;

    if (currentStep === 0) {
      //   const nameParts = valueToSave.trim().split(/\s+/);

      //   if (nameParts.length < 2) {
      //     setNameError("⚠ Please enter your first and last name");
      //     return;
      //   }

      // clear error if valid
      setNameError("");
      setUserName(valueToSave);
      setFirstName(getFirstName(valueToSave));
      setUserInitials(getInitials(valueToSave));
      setShowClearAll(true);
    }

    // let valueToSave = userInput;


    if (qid == 6) {
      valueToSave = toTitleCase(valueToSave);



      setCampaignNameError("");
    }


    // ✅ BUILD UPDATED ANSWERS
    const updated = {
      ...choicesMap,
      [qid]: valueToSave
    };

    setChoicesMap(updated);
    const campaignTypeValue = updated[4]; // 👈 ALWAYS reliable
    console.log("Campaign", campaignTypeValue)

    // STEP 3️⃣ calculate NEXT STEP (skip logic here)
    let nextStep;
    if (qid == 10 && campaignTypeValue == "Individual") {
      nextStep = QUESTIONS.findIndex(q => q.id == 12); // skip Q11
    } else {
      nextStep = currentStep + 1;
    }


    // ✅ SAVE CORRECT STEP
    if (tempUserId) {
      saveProgress(updated, nextStep);
    }

    const displayText = qid == 4 ? `$${valueToSave}` : valueToSave;

    // const displayText = qid == 6 ? `$${userInput}` : userInput;

    setMessages(prev => [...prev, { from: "user", text: displayText, qid }]);
    setUserInput("");

    // ✅ NAVIGATE USING SAME nextStep
    setTimeout(() => {
      if (nextStep < QUESTIONS.length) {
        setCurrentStep(nextStep);
        setMessages(prev => [
          ...prev,
          {
            from: "bot",
            text: QUESTIONS[nextStep].text,
            type: QUESTIONS[nextStep].type,
            options: QUESTIONS[nextStep].options || [],
            placeholder: QUESTIONS[nextStep].placeholder || "",
            qid: QUESTIONS[nextStep].id
          }
        ]);
      }
    }, 300);
  };

  const handleClearAll = async () => {
    try {
      if (tempUserId) {
        await fetch(`${baseUrl}/admin/deleteclearuser/${tempUserId}`, {
          method: "POST",
        });
      }
    } catch (err) {
      console.error("Failed to clear progress", err);
    }

    // 🔥 Clear local storage
    localStorage.removeItem("registrationUserId");

    // 🔥 Reset ALL state
    setTempUserId(null);
    setChoicesMap({});
    setMessages([]);
    setCurrentStep(0);
    setUserInput("");
    setUserName("");
    setFirstName("");
    setUserInitials("");
    setEmail("");
    setPhone("");
    setPassword("");
    setCampaignType(null);
    setQ11Choice(null);
    setQ11Text("");
    setAiDescription("");
    setShowClearAll(false);

    // 🔥 Restart chat
    const first = QUESTIONS[0];
    setMessages([
      {
        from: "bot",
        text: first.text,
        type: first.type,
        options: first.options || [],
        placeholder: first.placeholder || "",
        qid: first.id,
      },
    ]);
  };

  const handleSelect = (value, questionId) => {
    console.log("enetrrr.")
    setSelectedChoice(value);

    /* ======================================================
       ✅ SPECIAL CASE: QUESTION 3 (Campaign selection)
       ====================================================== */
    if (questionId == 3) {
      console.log("enetr", value)
      const selectedCampaign = campaignList?.find(c => c._id === value);
      if (!selectedCampaign) return;

      const updated = {
        ...choicesMap,

        // ✅ Question 3 answer (for resume / UI)
        3: {
          id: selectedCampaign._id,
          name: selectedCampaign.centerName
        },

        // ✅ Full campaign object (for backend payload)
        selectedCampaign: selectedCampaign
      };

      if (questionId == 4) {

        setCampaignType(value);


        let nextStep;

        if (value == "Individual") {
          nextStep = QUESTIONS.findIndex(q => q.id === 6); // ✅ skip Q5
        } else {
          nextStep = currentStep + 1;
        }

        if (tempUserId) {
          saveProgress(updated, nextStep);
        }
      }


      if (questionId == 10) {
        setCampaignType(value);

        let nextStep;

        if (value == "Individual") {
          nextStep = QUESTIONS.findIndex(q => q.id == 12); // ✅ skip Q5
        } else {
          nextStep = currentStep + 1;
        }

        if (tempUserId) {
          saveProgress(updated, nextStep);
        }
      }


      setChoicesMap(updated);

      if (tempUserId) {
        saveProgress(updated, currentStep + 1);
      }

      setMessages(prev => [
        ...prev,
        { from: "user", text: selectedCampaign.centerName, qid: 3 }
      ]);

      // ⛔ STOP here — do NOT run generic logic
      const next = currentStep + 1;
      if (next < QUESTIONS.length) {
        setCurrentStep(next);
        setMessages(prev => [
          ...prev,
          {
            from: "bot",
            text: QUESTIONS[next].text,
            type: QUESTIONS[next].type,
            options: QUESTIONS[next].options || [],
            placeholder: QUESTIONS[next].placeholder || "",
            qid: QUESTIONS[next].id
          }
        ]);
      }

      return;
    }

    /* ======================================================
       ✅ DEFAULT FLOW (ALL OTHER QUESTIONS)
       ====================================================== */

    const updated = {
      ...choicesMap,
      [questionId]: value
    };

    setChoicesMap(updated);

    if (tempUserId) {
      saveProgress(updated, currentStep + 1);
    }

    if (questionId === 4) {
      console.log("Enetetetet....")
      setCampaignType(value); // Individual | Organization
      sendOnboardingSelection(value)
    }

    if (questionId == 9) {
      setSelectedChoice(value); // only store temporarily
      return;
    }

    // if (questionId == 9) {
    //   console.log("enetrrr..9")
    //   setChoicesMap(prev => ({
    //     ...prev,
    //     9: value
    //   }));
    //   return; // ⛔ nothing else runs
    // }

    setTimeout(() => {
      setMessages(prev => [
        ...prev,
        { from: "user", text: value, qid: questionId }
      ]);

      let next = currentStep + 1;

      if (questionId === 4 && value === "Individual") {
        next = QUESTIONS.findIndex(q => q.id === 6);
      }

      if (next < QUESTIONS.length) {
        setCurrentStep(next);
        setMessages(prev => [
          ...prev,
          {
            from: "bot",
            text: QUESTIONS[next].text,
            type: QUESTIONS[next].type,
            options: QUESTIONS[next].options || [],
            placeholder: QUESTIONS[next].placeholder || "",
            qid: QUESTIONS[next].id
          }
        ]);
      }
    }, 350);
  };


  useEffect(() => {
    if (aiTextareaRef.current) {
      autoResizeTextarea(aiTextareaRef.current);
    }
  }, [aiDescription]);


  console.log("choicemap", choicesMap)






  const goToNextQuestion = () => {
    const next = currentStep + 1;

    if (QUESTIONS[next]?.id === 15) {
      next += 1;
    }

    if (next < QUESTIONS.length) {
      setCurrentStep(next);

      setMessages(prev => [
        ...prev,
        {
          from: "bot",
          text: QUESTIONS[next].text,
          type: QUESTIONS[next].type,
          options: QUESTIONS[next].options || [],
          placeholder: QUESTIONS[next].placeholder || "",
          qid: QUESTIONS[next].id
        }
      ]);
    }
  };

  const submitQ11 = () => {
    if (!q11Text.trim()) return;

    setChoicesMap(prev => ({
      ...prev,
      8: q11Text
    }));

    setMessages(prev => [
      ...prev,
      {
        from: "user",
        text: q11Text,
        qid: 8
      }
    ]);

    setQ11Text("");
    setQ11Choice(null);

    setTimeout(goToNextQuestion, 300);
  };
  // const submitQ11 = () => {
  //   if (!q11Text.trim()) return;

  //   setChoicesMap(prev => ({ ...prev, 11: q11Text }));

  //   setMessages(prev => [
  //     ...prev,
  //     { from: "user", text: q11Text, qid: 11 }
  //   ]);

  //   setQ11Text("");
  //   setQ11Choice(null);

  //   setTimeout(goToNextQuestion, 300);
  // };
  const handleEnterKey = (e, callback) => {
    if (QUESTIONS[currentStep]?.id === 9) {
      return;
    }
    if (e.key === "Enter") {
      e.preventDefault();
      callback();
    }
  };


  const checkPasswordStrength = (value) => {
    if (value.length < 6) return "Weak";
    if (
      value.length >= 8 &&
      /[A-Z]/.test(value) &&
      /[0-9]/.test(value) &&
      /[^A-Za-z0-9]/.test(value)
    ) {
      return "Strong";
    }
    return "Medium";
  };

  messages.forEach((msg, index) => {
    console.log(index, msg.qid, "mdgf");
  });

  const handleEmailPhoneEnterSubmit = async () => {
    if (isRegisterLoading) return;

    if (!email || !phone) {
      setEmailError("Email and phone number are required");
      return;
    }

    if (!validateEmail(email)) {
      setEmailError(
        "Hmm, that email doesn’t look quite right. Mind double-checking?"
      );
      setEmailErrorType("invalid");
      return;
    }

    try {
      setIsRegisterLoading(true);

      // build updated answers
      const updatedAnswers = {
        ...choicesMap,
        2: {
          email,
          phone
        }
      };

      setChoicesMap(updatedAnswers);

      // IMPORTANT: use existing invite record
      const existingUserId = id || tempUserId;

      if (existingUserId) {
        setTempUserId(existingUserId);
        localStorage.setItem(
          "registrationUserId",
          existingUserId
        );

        await fetch(`${baseUrl}/auth/save-progress`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            userId: existingUserId,
            answers: updatedAnswers,
            currentStep: 2
          })
        });
      }

      // clear validation errors
      setEmailError("");
      setEmailErrorType(null);

      // move next step
      const nextIndex = QUESTIONS.findIndex(
        (q) => q.id === 9
      );

      setCurrentStep(nextIndex);

      setMessages((prev) => [
        ...prev,
        {
          from: "user",
          text: `Email: ${email}\n\nPhone: ${phone}`,
          qid: 2
        },
        {
          from: "bot",
          text: QUESTIONS[nextIndex].text,
          type: QUESTIONS[nextIndex].type,
          options:
            QUESTIONS[nextIndex].options || [],
          placeholder:
            QUESTIONS[nextIndex].placeholder || "",
          qid: QUESTIONS[nextIndex].id
        }
      ]);
    } catch (err) {
      console.error(err);

      setEmailError(
        err.message ||
        "Something went wrong. Please try again."
      );
    } finally {
      setIsRegisterLoading(false);
    }
  };




  useEffect(() => {
    const savedUserId = localStorage.getItem("registrationUserId");
    if (savedUserId) {
      setTempUserId(savedUserId);
    }
  }, []);

  useEffect(() => {
    if (tempUserId) {
      setShowClearAll(true);
    }
  }, [tempUserId]);

  useEffect(() => {
    // IMPORTANT FIX
    // when invite flow is running, do NOT rebuild full chat
    if (!tempUserId || id) return;

    const fetchProgress = async () => {
      const res = await fetch(`${baseUrl}/auth/resume/${tempUserId}`);
      const data = await res.json();

      const progress = data?.progress?.[0];
      if (!progress) return;

      const answers = progress.answers || {};

      let step = progress.currentStep ?? 0;

      setChoicesMap(answers);
      setCurrentStep(step);

      const rebuiltMessages = [];

      QUESTIONS.forEach((question) => {
        const answer = answers[question.id];
        if (!answer) return;

        let displayText = "";

        if (question.id === 3) {
          displayText = answer?.name || "";
        } else if (question.type === "email_phone") {
          displayText = `Email: ${answer.email}\n\nPhone: ${answer.phone}`;
        } else {
          displayText = String(answer);
        }

        rebuiltMessages.push({
          from: "bot",
          text: question.text,
          type: question.type,
          options: question.options || [],
          qid: question.id
        });

        rebuiltMessages.push({
          from: "user",
          text: displayText,
          qid: question.id
        });
      });

      const nextQuestion = QUESTIONS[step];

      if (nextQuestion) {
        rebuiltMessages.push({
          from: "bot",
          text: nextQuestion.text,
          type: nextQuestion.type,
          options: nextQuestion.options || [],
          placeholder: nextQuestion.placeholder || "",
          qid: nextQuestion.id
        });
      }

      setMessages(rebuiltMessages);
    };

    fetchProgress();
  }, [tempUserId, id]);


  const buildRegisterPayload = () => {
    console.log("choicemap.......", choicesMap)
    const campaign = choicesMap.selectedCampaign || {};
    console.log("campaign", campaign);

    return {
      userId: tempUserId,   //
      // 🔹 Name
      contactPersonName: userName,

      // 🔹 Campaign selection
      campaignId: choicesMap[3]?.id,

      address: campaign.address,
      city: campaign.city,
      state: campaign.state,
      zipCode: campaign.zipCode,
      country: campaign.country,
      media: campaign.media,
      // 🔹 Individual or Organization
      campaignType: "Group", // Individual | Organization

      // 🔹 Organization name (ONLY if Organization)
      organizationName:
        choicesMap[4] === "Organization" || choicesMap[4] === "Church"
          ? choicesMap[5]
          : null,
      // organizationName:
      //   choicesMap[4] === "Organization" ? choicesMap[5] : null,

      // 🔹 Campaign details
      goal: Number(choicesMap[4]),
      campaignLaunchDate: choicesMap[5],
      centerName: choicesMap[6], // campaign name

      // 🔹 Contact preference
      contactPreference: choicesMap[9], // Email | Text | Email and Text
      email: choicesMap[2].email,
      phone: choicesMap[2].phone,
      // ✅ SMS CONSENT (only if text chosen)
      smsOptIn: choicesMap.smsOptIn || false,
      smsOptInAt: choicesMap.smsOptInAt || null,
      smsOptInSource: choicesMap.smsOptInSource || null,
      // 🔹 Descriptions
      // description: choicesMap[10],
      //   description: choicesMap.finalDescription || choicesMap[8],

      //   websiteOrDescription: choicesMap[7],

      description:
        choicesMap.finalDescription || choicesMap[10],

      websiteOrDescription: choicesMap[8],

      supportReason: choicesMap[7],

      // 🔹 Auth
      password,
      role: "user",
    };
  };

  const sendOnboardingSelection = async (roleValue) => {
    console.log("enetetetettet....")
    if (!tempUserId) return;

    const payload = {
      pageId: tempUserId,
      role:
        roleValue === "Organization" || roleValue === "Church"
          ? "ORGANIZER"
          : "SUPPORTING",
      // role: roleValue === "Organization" ? "ORGANIZER" : "SUPPORTING",
      recipientPageId: choicesMap[3]?.id || null,
    };

    try {
      await fetch(`${baseUrl}/admin/onboarding`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
    } catch (err) {
      console.error("Onboarding selection failed", err);
    }
  };

  // const today = new Date().toISOString().split("T")[0];
  const today = useMemo(() => {
    const now = new Date();

    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  }, []);

  const showFinalSteps = () => {
    const finalQuestions = QUESTIONS.filter(q => q.type === "final" && q.id !== 15);

    setMessages(prev => [
      ...prev,
      ...finalQuestions.map(q => ({
        from: "bot",
        text: q.text,
        type: q.type,
        qid: q.id
      }))
    ]);

    setCurrentStep(QUESTIONS.length - 1);
  };

  const rewriteWithAI = async (description, websiteUrl, churchDescription, groupName) => {
    console.log("description value:", description);
    console.log("description type:", typeof description);
    const res = await fetch(`${baseUrl}/admin/groupaitext`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ text: description, websiteUrl: websiteUrl, churchDescription, groupName })
    });

    const data = await res.json();
    return data.rewrittenText;
  };

  const updateGroupData = async (payload) => {
    try {

      const recordId = id || tempUserId;

      const res = await fetch(
        `${baseUrl}/admin/updategroupdata/${recordId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(payload)
        }
      );

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.message || "Update failed");
      }

      return data;
    } catch (error) {
      console.error("Update failed:", error);
      toast.error(error.message);
    }

  };

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile(); // initial check
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);





  return (
    <>
      <Helmet>
        <title>Campaign-register - Fund Life</title>
        {/* <meta name="description" content="Connect with women in need by registering your pregnancy center, maternity home, or adoption agency. Provide essential support and make a lasting impact." />
    <meta property="og:description" content="Connect with women in need by registering your pregnancy center, maternity home, or adoption agency. Provide essential support and make a lasting impact." />
    <meta name="keywords" content="Pregnancy center,Maternity home,Adoption agency,Register center,Essential support,Contact information,City and state,Zip code,Phone number,Network registration"/> */}
      </Helmet>
      <div className={style.mainregcontainer}>

        <div className={style.mainregform}>

        </div>

        <div className={style.contenboxmain}>
          <div className={style.contentBox}>
            <div className={style.innerregform}>
              <h1>HOPE</h1>
              {showClearAll && (
                <button
                  className={style.clearAllBtn}
                  onClick={handleClearAll}
                >
                  Clear all
                </button>
              )}
            </div>
            <div className={style.chatScrollArea} ref={chatScrollRef}>
              {messages.map((msg, index) => (
                <div
                  key={index}
                  className={`${msg.from === "bot" ? style.chatmain : style.chatResponse} ${style.fadeIn}`}
                >

                  {msg.from == "bot" && (
                    <>
                      <img src="/hopeimage.svg" className={style.hopeimage} />
                      <div className={style.botMsg}>
                        {/* <p>{msg.text}</p> */}
                        <p>
                          {(msg.qid === 12 && q11Choice === "No"
                            ? msg.text.replace("Thank you for sharing. ", "")
                            : msg.text)
                            .replace("{{name}}", firstName || "there")
                            .replace("{{campaignName}}", choicesMap?.centerNameLabel || "this organization")
                            .replace("{{orgName}}", choicesMap[5] || "this organization")}
                        </p>

                        {/* <p>
                          {msg.text.replace("{{name}}", firstName || "there").replace("{{campaignName}}", choicesMap.centerNameLabel || "this organization").replace("{{orgName}}", choicesMap[4] || "this organization")}
                        </p> */}


                        {/* TEXT INPUT */}
                        {msg.type === "text" && index === messages.length - 1 && (
                          <div className={style.inputWrapper}>
                            {MULTILINE_QUESTION_IDS.includes(msg.qid) ? (
                              /* TEXTAREA ONLY FOR Q10, Q11, Q12 */
                              <div className={style.flexInput}>
                                <textarea
                                  className={style.chatTextarea}
                                  placeholder={msg.placeholder}
                                  value={userInput}
                                  rows={1}
                                  onChange={(e) => {
                                    setUserInput(e.target.value);
                                    e.target.style.height = "auto";
                                    e.target.style.height = `${e.target.scrollHeight}px`;
                                  }}

                                  onKeyDown={(e) => handleEnterKey(e, handleUserSubmit)}
                                />
                                <img src="/arrowBtn.png" onClick={handleUserSubmit} />
                              </div>

                            ) : (
                              <div className={style.flexInput}>
                                <input
                                  type="text"
                                  placeholder={msg.placeholder}
                                  value={userInput !== "" ? userInput : choicesMap[msg.qid] || ""}
                                  onChange={(e) => {
                                    setUserInput(e.target.value);
                                    setNameError(""); // clear error when typing
                                  }}
                                  onKeyDown={(e) => handleEnterKey(e, handleUserSubmit)}
                                />

                                <img src="/arrowBtn.png" onClick={handleUserSubmit} />

                              </div>

                            )}
                            {nameError && (
                              <span className={style.errorMessagename}>{nameError}</span>)}
                            {campaignNameError && (
                              <span className={style.errorMessagename}>
                                {campaignNameError}
                              </span>
                            )}



                          </div>

                        )}

                        {msg.type === "dropdown" && msg.qid === 3 && index === messages.length - 1 && (
                          // <select
                          //   className={style.dropDown}
                          //   value={choicesMap[3] || ""}
                          //   onChange={(e) => handleSelect(e.target.value, msg.qid)}
                          // >
                          //   <option value="">Select</option>

                          //   {campaignList?.map(center => (
                          //     <option key={center._id} value={center._id}>
                          //       {center.centerName}
                          //     </option>
                          //   ))}
                          // </select>
                          <div className={style.dropdownRow}>
                            <select
                              className={style.dropDown}
                              value={choicesMap[3]?.id || prefilledCampaignId || ""}
                              onChange={(e) => {
                                const value = e.target.value;

                                // store selection
                                setChoicesMap(prev => ({
                                  ...prev,
                                  3: { id: value }
                                }));

                                // OPTIONAL: auto submit when value changes
                                handleSelect(value, 3);
                              }}
                            >
                              <option value="">Select</option>

                              {campaignList?.map(center => (
                                <option key={center._id} value={center._id}>
                                  {center.centerName}
                                </option>
                              ))}
                            </select>

                            {/* Arrow submit button */}
                            <img
                              src="/arrowBtn.png"
                              className={style.arrowBtn}
                              onClick={() => {
                                const value = choicesMap[3]?.id || prefilledCampaignId;

                                if (!value) return;

                                handleSelect(value, 3);
                              }}
                            />
                          </div>
                        )}


                        {msg.type == "dropdown" &&
                          msg.qid == 9 &&
                          currentStep == QUESTIONS.findIndex(q => q.id == 9) && (

                            <>
                              <select
                                className={style.dropDown}
                                value={choicesMap[9] || ""}
                                onChange={(e) => {
                                  handleSelect(e.target.value, msg.qid);

                                  // reset consent when selection changes
                                  setSmsConsentChecked(false);
                                  setSmsConsentError("");
                                }}
                              >
                                <option value="">Select</option>
                                {msg.options.map(opt => (
                                  <option key={opt} value={opt}>
                                    {opt}
                                  </option>
                                ))}
                              </select>

                              {/* ✅ SHOW CONSENT ONLY IF TEXT IS SELECTED */}
                              {(choicesMap[9] === "Text" || choicesMap[9] === "Email and Text") && (
                                <div className={style.smsConsentBox}>
                                  <div>
                                    <label className={style.smsCheckboxLabel}>
                                      <input
                                        type="checkbox"
                                        checked={smsConsentChecked}
                                        onChange={(e) => {
                                          setSmsConsentChecked(e.target.checked);
                                          setSmsConsentError("");
                                        }}
                                        className={style.checkboxtwilio}
                                      />

                                      <span>
                                        OPTIONAL: I agree to receive text message updates from FundLife.Me
                                        about my campaign progress at the phone number provided.
                                        I understand that subscription to text messaging is not required
                                        to create a campaign.
                                      </span>
                                    </label>

                                    <span className={style.twiliostop}>
                                      You may receive up to 7 messages per month.
                                    </span>

                                    <br />

                                    <span className={style.twiliostop}>
                                      Message and data rates may apply. Reply HELP for help or STOP to cancel.
                                    </span>

                                    <br />
                                    <div className={style.maininformationtwilio}>

                                      <div className={style.termsSeparate}>
                                        <a
                                          href="https://fundlife.me/termofservice"
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          className={style.termsLink}
                                        >
                                          Review our Terms and Conditions
                                        </a>
                                      </div>

                                      <div className={style.twilioInfoContainer}>
                                        <span
                                          className={style.twilioInlineInfo}
                                          onClick={() => setShowInfo((prev) => !prev)}
                                        >
                                          ⓘ
                                        </span>

                                        {showInfo && (
                                          <span className={style.twilioInlinePopup}>
                                            These messages include reminders to complete onboarding,
                                            notifications about activity on your fundraising page,
                                            and encouragement to share your campaign.
                                            You can opt out at any time.
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                  </div>

                                  <button
                                    className={style.continueBtn}
                                    onClick={() => {
                                      setChoicesMap((prev) => ({
                                        ...prev,
                                        9: selectedChoice,
                                        smsOptIn: smsConsentChecked,
                                        smsOptInAt: smsConsentChecked
                                          ? new Date().toISOString()
                                          : null,
                                        smsOptInSource: smsConsentChecked
                                          ? "campaign_registration_q9"
                                          : null,
                                      }));

                                      const nextIndex = QUESTIONS.findIndex((q) => q.id === 3);

                                      setMessages((prev) => [
                                        ...prev,
                                        {
                                          from: "user",
                                          text: selectedChoice,
                                        },
                                        {
                                          from: "bot",
                                          text: QUESTIONS[nextIndex].text,
                                          type: QUESTIONS[nextIndex].type,
                                          options: QUESTIONS[nextIndex].options || [],
                                          placeholder: QUESTIONS[nextIndex].placeholder || "",
                                          qid: QUESTIONS[nextIndex].id,
                                        },
                                      ]);

                                      setCurrentStep(nextIndex);
                                    }}
                                  >
                                    Continue
                                  </button>
                                </div>
                              )}
                              {/* ✅ CONTINUE FOR EMAIL ONLY */}
                              {choicesMap[9] === "Email" && (
                                <button
                                  className={style.continueBtnemail}
                                  onClick={() => {
                                    // ✅ add single user message
                                    setMessages(prev => [
                                      ...prev,
                                      { from: "user", text: "Email" }
                                    ]);

                                    const nextIndex = QUESTIONS.findIndex(q => q.id === 3);

                                    setCurrentStep(nextIndex);

                                    setMessages(prev => [
                                      ...prev,
                                      {
                                        from: "bot",
                                        text: QUESTIONS[nextIndex].text,
                                        type: QUESTIONS[nextIndex].type,
                                        options: QUESTIONS[nextIndex].options || [],
                                        placeholder: QUESTIONS[nextIndex].placeholder || "",
                                        qid: QUESTIONS[nextIndex].id
                                      }
                                    ]);

                                    // goToNextQuestion();
                                  }}
                                >
                                  Continue
                                </button>
                              )}

                            </>

                          )}


                        {msg.type === "choice" && (
                          <div className={style.choiceFlex}>
                            {msg.options.map((opt) => {
                              const persisted = choicesMap[msg.qid]; // value saved for that question (if any)
                              const isSelected = persisted ? persisted === opt : selectedChoice === opt;
                              return (
                                <button
                                  key={opt}
                                  onClick={() => {
                                    // if already answered, don't allow reselect (or allow, up to you)
                                    if (choicesMap[msg.qid]) return;
                                    handleSelect(opt, msg.qid);
                                  }}
                                  className={isSelected ? style.choiceBtnSelected : style.choiceBtn}
                                  disabled={!!choicesMap[msg.qid]} // disable after user selects
                                >
                                  {opt}
                                </button>
                              );
                            })}


                          </div>
                        )}
                        {/* ✅ AI TEXTAREA FOR QUESTION 13 */}
                        {msg.qid == 13 && index == messages.length - 1 && (
                          <>
                            <textarea
                              ref={aiTextareaRef}
                              className={style.choiceTextarea}
                              value={
                                choicesMap.finalDescription ||
                                aiDescription ||
                                "Ai Generating Description..."
                              }
                              readOnly
                              rows={1}
                              onChange={() => { }}
                              style={{ overflow: "hidden", resize: "none" }}
                              onInput={(e) => autoResizeTextarea(e.target)}
                            />
                            <h5 className={style.aiHint}>
                              You can always modify your description once you log into your campaign.
                            </h5>
                          </>
                        )}
                        {msg.type == "yes_no_input" && msg.qid === 8 && index === messages.length - 1 && (
                          <div className={style.q11Wrapper}>

                            {/* YES / NO BUTTONS */}
                            <div className={style.choiceFlex}>
                              {["Yes", "No"].map(opt => (
                                <button
                                  key={opt}
                                  className={q11Choice === opt ? style.choiceBtnSelected : style.choiceBtn}
                                  onClick={() => {
                                    setQ11Choice(opt);

                                    // USER CHOSE NO → SKIP TEXTAREA
                                    if (opt === "No") {
                                      setChoicesMap(prev => ({ ...prev, 11: "" }));

                                      setMessages(prev => [
                                        ...prev,
                                        { from: "user", text: "No", qid: 11 }
                                      ]);

                                      setTimeout(goToNextQuestion, 300);
                                    }
                                  }}
                                >
                                  {opt}
                                </button>
                              ))}
                            </div>

                            {/* TEXTAREA ONLY IF YES */}
                            {q11Choice === "Yes" && (
                              <div className={style.inputWrapperchatarea}>
                                <textarea
                                  className={style.chatTextareadescription}
                                  placeholder="Enter website or short description"
                                  value={q11Text}
                                  rows={1}
                                  onChange={(e) => {
                                    setQ11Text(e.target.value);
                                    e.target.style.height = "auto";
                                    e.target.style.height = `${e.target.scrollHeight}px`;
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      e.preventDefault();
                                      submitQ11();

                                      //   if (!q11Text.trim()) return;

                                      //   setChoicesMap(prev => ({ ...prev, 11: q11Text }));

                                      //   setMessages(prev => [
                                      //     ...prev,
                                      //     { from: "user", text: q11Text, qid: 11 }
                                      //   ]);

                                      //   setQ11Text("");
                                      //   setQ11Choice(null);

                                      //   setTimeout(goToNextQuestion, 300);
                                    }
                                  }}

                                />
                                {/* Arrow submit button */}
                                <img
                                  src="/arrowBtn.png"
                                  className={style.sendIcon}
                                  onClick={submitQ11}
                                />
                              </div>
                            )}
                          </div>
                        )}

                        {msg.type == "number" && index == messages.length - 1 && (
                          <div className={style.amountRow}>
                            <div className={style.amountInputBox}>
                              <div>
                                <span className={style.amountDollar}>$</span>
                                <input
                                  type="number"
                                  placeholder="Enter Amount"
                                  value={userInput || choicesMap[4] || ""}

                                  onChange={(e) => setUserInput(e.target.value)}
                                  onKeyDown={(e) => handleEnterKey(e, handleUserSubmit)}
                                />
                              </div>
                              <img src="/arrowBtn.png" onClick={handleUserSubmit} className={style.sendIcon} />

                            </div>
                          </div>
                        )}
                        {msg.type === "date" && index === messages.length - 1 && (
                          <>
                            {!isMobile ? (
                              /* ================= DESKTOP ================= */
                              <div className={style.dateWrapper}>
                                <div className={style.customDateBox}>
                                  <img
                                    src="/calendar.png"
                                    className={style.calendarIcon}
                                    onClick={() => {
                                      if (dateRef.current?.showPicker) {
                                        dateRef.current.showPicker();
                                      } else {
                                        dateRef.current?.focus();
                                      }
                                    }}
                                  />
                                </div>

                                <input
                                  type="date"
                                  ref={dateRef}
                                  min={today}
                                  value={choicesMap[msg.qid] || ""}
                                  className={style.dateInputCustom}


                                  onClick={(e) => {
                                    e.currentTarget.showPicker?.();
                                  }}

                                  onChange={(e) => {
                                    const value = e.target.value;
                                    if (!value) return;

                                    setChoicesMap(prev => ({
                                      ...prev,
                                      [msg.qid]: value
                                    }));

                                    setMessages(prev => [
                                      ...prev,
                                      { from: "user", text: value }
                                    ]);

                                    setTimeout(goToNextQuestion, 300);
                                  }}
                                />
                                {/* NEW ARROW BUTTON */}
                                    <img
                                      src="/arrowBtn.png"
                                      className={style.arrowBtn}
                                      onClick={() => {
                                        const selectedDate = choicesMap[msg.qid];

                                        if (!selectedDate) return;

                                        setMessages((prev) => [
                                          ...prev,
                                          { from: "user", text: selectedDate }
                                        ]);

                                        setTimeout(goToNextQuestion, 300);
                                      }}
                                    />
                              </div>
                            ) : (
                              /* ================= MOBILE ================= */
                              <div className={style.mobileDateWrapper}>
                                <div
                                  className={style.fakeDateInput}
                                  onClick={() => setShowCalendar(true)}
                                >
                                  <img
                                    src="/calendar.png"
                                    alt="calendar"
                                    className={style.mobileCalendarIcon}
                                  />
                                  {choicesMap[msg.qid]
                                    ? choicesMap[msg.qid]
                                    : "dd-mm-yy"}

                                </div>

                                {showCalendar && (
                                  <div className={style.calendarPopup}>
                                    <Calendar
                                      minDate={new Date()}
                                      onChange={(date) => {
                                        const formatted = [
                                          date.getFullYear(),
                                          String(date.getMonth() + 1).padStart(2, "0"),
                                          String(date.getDate()).padStart(2, "0"),
                                        ].join("-");

                                        setChoicesMap(prev => ({
                                          ...prev,
                                          [msg.qid]: formatted
                                        }));

                                        setMessages(prev => [
                                          ...prev,
                                          { from: "user", text: formatted }
                                        ]);

                                        setShowCalendar(false);

                                        setTimeout(goToNextQuestion, 400);
                                      }}
                                    />

                                    {/* NEW ARROW BUTTON */}
                                    <img
                                      src="/arrowBtn.png"
                                      className={style.arrowBtn}
                                      onClick={() => {
                                        const selectedDate = choicesMap[msg.qid];

                                        if (!selectedDate) return;

                                        setMessages((prev) => [
                                          ...prev,
                                          { from: "user", text: selectedDate }
                                        ]);

                                        setTimeout(goToNextQuestion, 300);
                                      }}
                                    />
                                  </div>
                                )}
                              </div>
                            )}
                          </>
                        )}

                        {msg.qid === 11 && (
                          <>
                            <textarea
                              ref={aiTextareaRef}
                              className={style.choiceTextarea}
                              value={
                                aiDescription ||
                                choicesMap.finalDescription ||
                                "AI Generating Description..."
                              }
                              readOnly
                              rows={6}
                            />
                            <h5 className={style.aiHint}>
                              You can always modify your description once you log into your campaign.
                            </h5>
                          </>
                        )}
                        {msg.qid === 2 && index === messages.length - 1 && (
                          <div className={style.emailBoxGroup}>

                            {/* LOADER OVERLAY */}
                            {isRegisterLoading && (
                              <div className={style.loaderOverlay}>
                                <Spinner animation="border" />
                              </div>
                            )}

                            {/* EMAIL INPUT */}
                            <div className={style.emailinputmainchat}>
                              <input
                                type="email"
                                placeholder="Enter your email"
                                value={email}
                                disabled={isRegisterLoading}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  setEmail(value);

                                  if (!value) {
                                    setEmailError("");
                                    setEmailErrorType(null);
                                    return;
                                  }

                                  if (!validateEmail(value)) {
                                    setEmailError("This email doesn’t look valid (e.g. name@gmail.com)");
                                    setEmailErrorType("invalid");
                                  } else {
                                    setEmailError("");
                                    setEmailErrorType(null);
                                  }
                                }}
                                className={`${style.emailInput} ${emailError ? style.errorBorder : ""}`}
                              />
                              {emailError && (


                                <span className={`${style.errorMessage} ${emailErrorType == "exists" ? style.errorExists : ""
                                  }`}>
                                  <img
                                    src="/Vector.png"   // or png
                                    alt="error"
                                    className={style.errorIcon}
                                  />
                                  {emailError}
                                </span>

                              )}
                            </div>

                            {/* PHONE INPUT */}
                            <div className={style.inputError}>
                              <PhoneInput
                                country={"us"}               // default country
                                value={phone}
                                onChange={(value) => setPhone(value)}
                                excludeCountries={["io"]}
                                // inputClass={style.phoneInput}
                                // containerClass={style.phoneContainer}
                                enableSearch
                                countryCodeEditable={false}
                                onKeyDown={(e) => handleEnterKey(e, handleEmailPhoneEnterSubmit)}
                                containerStyle={{
                                  width: "100%",
                                }}

                                inputStyle={{
                                  width: "100%",
                                  height: "40px",
                                  fontSize: isMobile ? "10px" : "12px",
                                  boxShadow: "none",
                                  borderColor: "#DEE2E6"
                                  // boxSizing: "border-box",
                                }}
                                onFocus={() => setTimeout(scrollChatToBottom, 150)}

                              />

                              {!isRegisterLoading && (
                                <img
                                  src="/arrowBtn.png"
                                  onClick={handleEmailPhoneEnterSubmit}
                                  className={style.arrowemail}
                                />
                              )}
                            </div>
                            {emailError && emailErrorType == "invalid" && (
                              <>
                                <input
                                  type="text"
                                  placeholder="Re-enter correct email"
                                  className={style.emailInput}
                                  onChange={(e) => setEmail(e.target.value)}
                                  onKeyDown={(e) => handleEnterKey(e, handleEmailPhoneEnterSubmit)}
                                />
                              </>
                            )}
                          </div>
                        )}

                        {msg.type === "choice_text" && index === messages.length - 1 && (
                          <div className={style.choiceTextWrapper}>


                            <div className={style.choiceFlex}>
                              {msg.options.map(opt => (
                                <button
                                  key={opt}
                                  className={q11Choice === opt ? style.choiceBtnSelected : style.choiceBtn}
                                  onClick={async () => {
                                    const originalDescription = choicesMap[10]; // Q10 description

                                    if (opt === "No") {
                                      const updated = {
                                        ...choicesMap,
                                        10: "No",
                                        finalDescription: choicesMap[7]
                                      };

                                      setChoicesMap(updated);

                                      if (tempUserId) {
                                        saveProgress(updated, QUESTIONS.findIndex(q => q.id === 12));
                                      }

                                      setMessages(prev => [
                                        ...prev,
                                        { from: "user", text: "No", qid: 10 }
                                      ]);

                                      const passwordIndex = QUESTIONS.findIndex(q => q.id === 12);

                                      setCurrentStep(passwordIndex);

                                      setMessages(prev => [
                                        ...prev,
                                        {
                                          from: "bot",
                                          text: QUESTIONS[passwordIndex].text,
                                          type: QUESTIONS[passwordIndex].type,
                                          qid: QUESTIONS[passwordIndex].id
                                        }
                                      ]);

                                      return;
                                    }

                                    if (opt === "Yes") {
                                      const stepData = {
                                        ...choicesMap,
                                        10: "Yes"
                                      };

                                      setChoicesMap(stepData);

                                      // show loading immediately
                                      setAiDescription("AI Generating Description...");

                                      const centerName =
                                        choicesMap[6] || "";
                                      console.log("cnetrname", centerName)
                                      const groupName = centerName
                                        .split("-")[0]
                                        .trim();
                                      console.log(groupName, "groupName")
                                      const aiText = await rewriteWithAI(
                                        choicesMap[7],
                                        choicesMap[8] || "",
                                        churchDescription,
                                        groupName
                                      );

                                      // const aiText = await rewriteWithAI(
                                      //   choicesMap[7],
                                      //   choicesMap[8]
                                      // );

                                      const finalData = {
                                        ...stepData,
                                        finalDescription: aiText
                                      };

                                      setChoicesMap(finalData);
                                      setAiDescription(aiText);

                                      const next = QUESTIONS.findIndex(q => q.id === 11);

                                      setCurrentStep(next);

                                      setMessages(prev => [
                                        ...prev,
                                        {
                                          from: "bot",
                                          text: QUESTIONS[next].text,
                                          type: QUESTIONS[next].type,
                                          options: QUESTIONS[next].options,
                                          qid: QUESTIONS[next].id
                                        }
                                      ]);

                                      if (tempUserId) {
                                        saveProgress(finalData, next);
                                      }

                                      return;
                                    }


                                  }}

                                >
                                  {opt}
                                </button>
                              ))}
                            </div>



                            <textarea
                              className={style.choiceTextarea}
                              value={
                                aiDescription ||
                                choicesMap.finalDescription ||
                                choicesMap[7] ||
                                ""
                              }
                              // value={aiDescription || choicesMap.finalDescription || choicesMap[7] || ""}
                              readOnly
                            />

                            {/* SUBMIT */}

                          </div>
                        )}

                        {msg.type === "password" && index === messages.length - 1 && (
                          <div className={style.passwordBox}>

                            <p className={style.passwordHint}>
                              Strong passwords protect your work. Use at least 8 characters, including a number and symbol.
                            </p>

                            <input
                              type="password"
                              className={style.passwordInput}
                              value={password}
                              onChange={(e) => {
                                const val = e.target.value;
                                setPassword(val);
                                setPasswordStrength(checkPasswordStrength(val));
                              }}
                              placeholder="Enter password"
                            />

                            {password && (
                              <span
                                className={`${style.passwordStrength} ${passwordStrength === "Strong"
                                  ? style.strong
                                  : passwordStrength === "Medium"
                                    ? style.medium
                                    : style.weak
                                  }`}
                              >
                                {passwordStrength}
                              </span>
                            )}

                            <button
                              className={style.savePasswordBtn}
                              disabled={passwordStrength !== "Strong"}
                              onClick={async () => {
                                setMessages(prev => [
                                  ...prev,
                                  { from: "user", text: "Password set successfully" }
                                ]);

                                showFinalSteps();

                                const payload = buildRegisterPayload();

                                try {
                                  const res = await updateGroupData(payload);

                                  toast.success("Updated successfully");

                                  setCreatedCampaignId(res?.data?._id);
                                  setShowClearAll(false);

                                  if (res?.smsError) {
                                    toast.warning(res.smsError);
                                  }

                                  setPassword("");
                                  setPasswordStrength("");

                                  localStorage.removeItem("registrationUserId");
                                } catch (error) {
                                  console.error("Update failed:", error);
                                  toast.error("Update failed. Please try again.");
                                }
                              }}

                            >
                              Save Password
                            </button>
                          </div>
                        )}


                        {msg.type === "final" && (
                          <div className={style.finalStepBox}>

                            {/* ICON ONLY FOR Q14 & Q15 */}
                            {(msg.qid === 12 || msg.qid === 13) && (
                              <img
                                src={msg.qid === 16 ? "/tick.png" : "/heart.png"}
                                className={style.finalImage}
                                alt="final step"
                              />
                            )}

                            {/* CTA FOR Q14 */}
                            {msg.qid === 12 && (
                              <button
                                className={style.continueBtn}
                                onClick={() => goToNextQuestion()}
                              >
                                Continue
                              </button>
                            )}

                            {/* CTA FOR Q15 */}
                            {msg.qid === 13 && (
                              <button
                                className={style.continueBtn}
                                onClick={openDonateModal}
                              >
                                Make a Gift
                              </button>
                            )}

                            {msg.qid === 14 && (
                              <button
                                className={style.continueBtn}
                                onClick={() => window.open("https://admin.fundlife.me/", "_blank")}
                              >
                                Log In Admin Panel
                              </button>
                            )}



                          </div>
                        )}





                      </div>
                    </>
                  )}


                  {msg.from === "user" && (
                    <div className={style.userRow}>

                      <span
                        className={
                          msg.isLoading
                            ? style.typingChat
                            : MULTILINE_QUESTION_IDS.includes(msg.qid)
                              ? style.chatMultiline
                              : style.chat
                        }
                      >

                        {msg.isLoading ? (
                          <span className={style.typingDotsWrapper}>
                            <span className={style.typingDots}>
                              <span>.</span><span>.</span><span>.</span>
                            </span>
                          </span>
                        ) : (
                          msg.text
                        )}
                      </span>

                      <div className={style.userAvatar}>{userInitials}</div>
                    </div>
                  )}


                </div>
              ))}
              <div ref={chatEndRef} />
            </div>

          </div>
        </div>




      </div>



      <CenterRegisterSuccess
        showSuccessModal={showSuccessModal}
        setShowSucessModal={setShowSucessModal}
      />
      <DonateModal
        show={showDonateModal}
        onHide={closeDonateModal}
        prefill={donationPrefill}
      />

    </>
  );
};

export default GroupRegister;